// WW-178 · external covers load through the admin image proxy (hotlink blocks); own covers unchanged.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function coverSrc(url) {
  const u = (url || "").trim();
  if (!u) return "";
  if (u.startsWith("/")) return `${BACKEND}${u}`;
  if (!/^https?:\/\//i.test(u)) return u;
  if (u.startsWith(BACKEND) || u.includes("/drive-watcher/blob/")) return u;
  return `${BACKEND}/api/admin/drive-watcher/image-proxy?url=${encodeURIComponent(u)}`;
}
